import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { X } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const BACKEND = API.replace('/api', '');

export default function HomepagePopup() {
  const [popup, setPopup] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    axios.get(`${API}/public/popup`).then(r => {
      if (r.data && r.data.enabled) setPopup(r.data);
    }).catch(() => {});
  }, []);

  if (!popup || dismissed) return null;

  const imgSrc = popup.image_url?.startsWith('/api') ? `${BACKEND}${popup.image_url}` : popup.image_url;

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 10000, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px', backdropFilter: 'blur(4px)' }} data-testid="homepage-popup" onClick={() => setDismissed(true)}>
      <div style={{ background: 'white', borderRadius: '20px', maxWidth: '560px', width: '100%', overflow: 'hidden', position: 'relative', boxShadow: '0 24px 48px rgba(0,0,0,0.2)', animation: 'popupSlide 0.3s ease' }} onClick={e => e.stopPropagation()}>
        <button onClick={() => setDismissed(true)} data-testid="popup-close" style={{ position: 'absolute', top: '12px', right: '12px', zIndex: 10, width: '32px', height: '32px', borderRadius: '50%', background: 'rgba(0,0,0,0.5)', color: 'white', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <X size={16} />
        </button>

        {popup.image_url && (
          <div style={{ width: '100%', maxHeight: '300px', overflow: 'hidden' }}>
            <img src={imgSrc} alt={popup.title || ''} style={{ width: '100%', height: 'auto', display: 'block', objectFit: 'cover' }} />
          </div>
        )}
        {popup.video_url && !popup.image_url && (
          <div style={{ width: '100%', position: 'relative', paddingBottom: '56.25%' }}>
            <iframe src={popup.video_url} title={popup.title || 'Video'} style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0 }} allowFullScreen />
          </div>
        )}

        <div style={{ padding: '28px', textAlign: 'center' }}>
          {popup.title && (
            <h2 style={{ fontFamily: 'Poppins, sans-serif', fontSize: '22px', fontWeight: 800, color: '#0c3c60', marginBottom: '12px', lineHeight: 1.3 }}>{popup.title}</h2>
          )}
          {popup.description && (
            <div style={{ fontSize: '14px', color: '#4b5563', lineHeight: 1.7, marginBottom: '20px', fontFamily: 'Inter, sans-serif' }} dangerouslySetInnerHTML={{ __html: popup.description }} />
          )}
          {popup.button_text && popup.button_url && (
            <a href={popup.button_url} target={popup.button_url.startsWith('http') ? '_blank' : '_self'} rel="noreferrer" data-testid="popup-cta-btn"
              style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', background: '#0c3c60', color: 'white', textDecoration: 'none', padding: '12px 28px', borderRadius: '10px', fontWeight: 700, fontFamily: 'Poppins, sans-serif', fontSize: '14px', transition: 'background 0.2s' }}>
              {popup.button_text}
            </a>
          )}
        </div>
      </div>
      <style>{`
        @keyframes popupSlide { from { opacity: 0; transform: scale(0.95) translateY(10px); } to { opacity: 1; transform: scale(1) translateY(0); } }
      `}</style>
    </div>
  );
}
